<template>
  <div v-if="$apollo.loading">
    <spinner />
  </div>
  <div v-else class="page-wrapper">
    <div v-if="!regular.length && !parter.length && !table.length" class="upper-container">
      <div class="title-screen">
        <span>Floor plan</span>
      </div>
      <p class="page-description">
        To edit your floor plan and seating layouts, first add tickets that will connect to seats.
      </p>
      <div class="mobile-button">
        <main-button text="Go to tickets" @click="goTo(routes.organizer.tickets)" />
      </div>
    </div>
    <create-floor-plan
      v-else
      :initial-venue="initialVenue"
      :init-regular="regular"
      :init-table="table"
      :init-parter="parter"
      :venues="venues"
      :init-venue-availability="venueAvailability"
      :event-id="eventId"
      :organization-slug="organizationSlug"
      :is-any-ticket-already-sold-or-booked="isAnyTicketAlreadySoldOrBooked"
      @changeVenue="loadSelectedVenue($event)"
      @ticketSoldInTheMeantime="refetchVenue()"
      @resetVenue="resetVenueAvailability()"
    />
  </div>
</template>

<script>
import { GET_EVENT_FLOOR_PLAN } from '../../graphql/event.graphql'
import { changeEventVenue, resetVenueAvailability } from '../../http'
import moment from 'moment'
import CreateFloorPlan from './CreateFloorPlan.vue'

export default {
  name: 'floor-plan-container',
  components: { CreateFloorPlan },
  props: {
    eventId: String,
    user: Object,
    organizationSlug: String,
  },
  data() {
    return {
      form: { type: null },
      venues: [],
      regular: [],
      parter: [],
      table: [],
      venueAvailability: {},
      initialVenue: {},
      isAnyTicketAlreadySoldOrBooked: false,
    }
  },
  apollo: {
    getEventFloorPlan: {
      query: GET_EVENT_FLOOR_PLAN,
      variables() {
        return {
          eventId: this.eventId,
        }
      },
      manual: true,
      async result({ data, loading }) {
        if (data && !loading) {
          this.initialVenue = data.getVenues.find(v => v.id === data.getEventFloorPlan.venueId)
          this.venues = data.getVenues.filter(venue => venue.seats && venue.predefinedSections)
          if (!this.initialVenue) {
            this.initialVenue = this.venues[0]
          }
          this.regular = data.getEventFloorPlan.orderItems.filter(
            oi => moment(oi.to).isAfter(new Date()) && !oi.itemMeta.parter && !oi.itemMeta.table,
          )
          this.parter = data.getEventFloorPlan.orderItems.filter(
            oi => moment(oi.to).isAfter(new Date()) && oi.itemMeta.parter,
          )
          this.table = data.getEventFloorPlan.orderItems.filter(
            oi => moment(oi.to).isAfter(new Date()) && oi.itemMeta.table,
          )
          this.venueAvailability =
            data.getEventFloorPlan.venueAvailability &&
            data.getEventFloorPlan.venueAvailability.availability

          this.isAnyTicketAlreadySoldOrBooked =
            this.venueAvailability &&
            Object.values(this.venueAvailability).some(
              seat => seat['state'] === 'hold' || seat['state'] === 'sold',
            )
        }
      },
    },
  },
  methods: {
    async loadSelectedVenue(venue) {
      await changeEventVenue({ eventId: this.eventId, venueId: venue.id })
      await this.$apollo.queries.getEventFloorPlan.refetch()
    },
    async refetchVenue() {
      await this.$apollo.queries.getEventFloorPlan.refetch()
    },
    async resetVenueAvailability() {
      await resetVenueAvailability({
        eventId: this.eventId,
        organizationSlug: this.organizationSlug,
      })
      this.refetchVenue()
    },
  },
}
</script>

<style scoped>
.page-description {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 1rem;
  color: #979797;
}
.upper-container {
  max-width: 42.75rem;
}
.mobile-button {
  margin-top: 1.5rem;
}
@media screen and (max-width: 800px) {
  .page-wrapper {
    margin-top: 1.5rem;
  }
}
</style>
